var _rect, _g, _rect2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopyBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 38,
    height: 38,
    rx: 19,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8948_27557)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21 28C22.3256 27.9984 23.5964 27.4711 24.5338 26.5338C25.4711 25.5965 25.9984 24.3256 26 23V14.243C26.0016 13.7174 25.8988 13.1967 25.6976 12.711C25.4964 12.2254 25.2008 11.7846 24.828 11.414L22.586 9.17202C22.2155 8.79919 21.7746 8.50362 21.289 8.30244C20.8034 8.10125 20.2826 7.99846 19.757 8.00002H15C13.6744 8.00161 12.4036 8.5289 11.4662 9.46624C10.5289 10.4036 10.0016 11.6744 10 13V23C10.0016 24.3256 10.5289 25.5965 11.4662 26.5338C12.4036 27.4711 13.6744 27.9984 15 28H21ZM12 23V13C12 12.2044 12.3161 11.4413 12.8787 10.8787C13.4413 10.3161 14.2044 10 15 10C15 10 19.919 10.014 20 10.024V12C20 12.5305 20.2107 13.0392 20.5858 13.4142C20.9609 13.7893 21.4696 14 22 14H23.976C23.986 14.081 24 23 24 23C24 23.7957 23.6839 24.5587 23.1213 25.1213C22.5587 25.6839 21.7956 26 21 26H15C14.2044 26 13.4413 25.6839 12.8787 25.1213C12.3161 24.5587 12 23.7957 12 23ZM30 16V27C29.9984 28.3256 29.4711 29.5965 28.5338 30.5338C27.5964 31.4711 26.3256 31.9984 25 32H16C15.7348 32 15.4804 31.8947 15.2929 31.7071C15.1054 31.5196 15 31.2652 15 31C15 30.7348 15.1054 30.4804 15.2929 30.2929C15.4804 30.1054 15.7348 30 16 30H25C25.7956 30 26.5587 29.6839 27.1213 29.1213C27.6839 28.5587 28 27.7957 28 27V16C28 15.7348 28.1054 15.4804 28.2929 15.2929C28.4804 15.1054 28.7348 15 29 15C29.2652 15 29.5196 15.1054 29.7071 15.2929C29.8946 15.4804 30 15.7348 30 16Z",
    fill: "hsla(200, 53%, 23%, 0.7)"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 38,
    height: 38,
    rx: 19,
    stroke: "hsla(200, 53%, 23%, 0.7)",
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8948_27557"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyBtn);
export default __webpack_public_path__ + "static/media/copyBtn.cd67bf5f51120accbf81cc945bfc4dd4.svg";
export { ForwardRef as ReactComponent };